import { BaseAuthService } from './BaseAuthService';
import { BACKEND_ROOT } from '../../config/host-config';
import { NotificationService } from '../../services';
import { UserReportType } from '../../models';

export class SurveyReportTypeDataService extends BaseAuthService {
    private endpointRoot = `${BACKEND_ROOT}/api/surveyReportType`;
    private notificationService: NotificationService;

    constructor(notificationService: NotificationService) {
        super();
        this.notificationService = notificationService;
    }

    getBySurvey(id: number, orgId?: number) {
        var endpoint = `${this.endpointRoot}/bysurvey/${id}`;
        if (orgId) {
            endpoint += `/${orgId}`;
        }

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                const message = `Error retrieving survey report type data.`;
                this.notificationService.addError(message);
                throw new Error(message);
            });
    }

    getBySurveyVersion(id: number) {
        var endpoint = `${this.endpointRoot}/bysurveyversion/${id}`;
        
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                const message = `Error retrieving survey report type data.`;
                this.notificationService.addError(message);
                throw new Error(message);
            });
    }
    
    public getAllForUser(userId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/forUser/${userId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving survey report types for user.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public createUserSurveyReportType(entity: UserReportType): Promise<any> {

        const endpoint = `${this.endpointRoot}/userReportType/`;
        const init = this.buildRequestInit('POST', entity);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification(`Survey Report Type User created successfully.`);
                return response.json();
            }

            const message = `Error creating Survey Report Type User.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public deleteUserSurveyReportType(id: number): Promise<any> {

        const endpoint = `${this.endpointRoot}/userReportType/${id}`;
        const init = this.buildRequestInit('DELETE');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification(`Survey Report Type User deleted successfully.`);
                return response.json();
            }

            const message = `Error deleting Survey Report Type User.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/services/api/SurveyReportType.tsx